module.exports = __webpack_public_path__ + "static/media/thank-you-new-bg.131b8499.svg";